// Claims stay inside the custom-trophy boundaries recorded in .seo/truth.md:
// no fixed price, turnaround, minimum, rush, Pantone or solid-metal promise.
// Turnaround is the owner's (2026-11-03): 4–6 weeks standard; rush in 1–2
// weeks depending on complexity, budget and destination.
const customTrophy = {
  path: '/services/custom-trophy/',
  reviewedDate: '2026-10-16',
  title: 'Custom 3D Printed Trophies & Awards from $250',
  description:
    'Custom 3D printed trophies from $250 each, made in New York from your sketch or photo. Free concept mockup and no minimum order.',
  summary:
    'PrintAWorld is a New York studio that designs and makes custom 3D printed trophies and awards for companies, leagues, tournaments, and events. Projects usually start from a sketch, photo, or logo; PrintAWorld sends a free concept mockup, then models the trophy in 3D, prints it in resin, and finishes it with paint or metal plating, a base, and engraved names. Trophies start at $250 each with no minimum order, plus a one-time 3D modeling and design fee, $250 for most projects.',
}

const assetRoot = 'https://images.ctfassets.net/dovsnf6qrcem/'
// Cloudflare Images account hash (public; part of every delivery URL).
const cloudflareImagesHash = 'pnE9JECNN7kGa4W-Gfqs7g'

// One URL builder for both hosts. Contentful and Cloudflare Images both
// resize on demand and serve WebP/AVIF to browsers that support it.
const photoUrl = (photo, width, quality = 80) =>
  photo.cf
    ? `https://imagedelivery.net/${cloudflareImagesHash}/${photo.cf}/w=${width},quality=${quality}`
    : `${assetRoot}${photo.file}?w=${width}&q=${quality}&fm=webp`

const photos = {
  rcCatsSet: {
    cf: 'trophy-rc-cat-awards-set',
    alt: 'Five gold cat trophies in red RC jerseys and gaming headsets, with red flame wings on black stepped bases',
    ratio: 1.45,
  },
  rcCat: {
    cf: 'trophy-rc-cat-award',
    alt: 'A gold cat trophy in a red RC jersey and headset with flame wings, on a twisted gold column and black stepped base',
    ratio: 0.667,
    fit: 'contain',
  },
  tribeGorillas: {
    cf: 'trophy-tribe-gorilla-awards',
    alt: 'Two chrome gorilla trophies on black bases with gold TRIBE award plates',
    ratio: 1.5,
  },
  formicArm: {
    cf: 'trophy-formic-robot-arm-award',
    alt: 'An orange scale model of a Formic robot arm on a black base with the Formic logo',
    ratio: 0.5625,
    fit: 'contain',
  },
  goGetter: {
    file: 'OoaDnsWRzVJpofIf772Y6/b9738d130aa42ebe7f290e1d4d395fb9/3d_printed_custom_trophies_for_dunkin_donuts.jpg',
    alt: 'A set of orange Go Getter trophies with personalized name plates',
    ratio: 1.5,
  },
  spark: {
    file: '5WAuOseP7Jzgcjmbf8EPcO/130cc9962db1bd603759495d2c9cbf5b/LAL_7297.jpg',
    alt: 'Two tall red Spark trophies with gold stars on personalized black bases',
    ratio: 0.667,
    fit: 'contain',
  },
  streetEasy: {
    file: '4VXzsd31ZXjO9dy5omhyWd/615f3bb0c91c6008b4227e77f9f7dcde/street_easy_custom_trophy.jpg',
    alt: 'Three blue StreetEasy logo trophies on white bases',
    ratio: 1.5,
  },
  iHeart: {
    file: '62i97iVEL24bfoXr7SbhuJ/010481fff8d43caab14a9989a1a2001e/_DSC8339.jpg',
    alt: 'Three matte black iHeartRadio logo trophies',
    ratio: 1.5,
  },
  telly: {
    file: '5rK3YYWh31R9DxMicIdNJu/cf99a69cb4c655c2ed6dd1015ffeff68/LAL_7611.jpg',
    alt: 'Two magenta character awards tipping their hats on black bases',
    ratio: 1.5,
  },
  dinosaur: {
    file: '2lS2QI1fMNRELrn74SzgtI/1ef19f396b54bf92ba806d55f389ddcc/acrylic_keychain-6.jpg',
    alt: 'A pink dinosaur award standing on a wood base',
    ratio: 0.667,
  },
  topDog: {
    file: '2mZAyv3IePbos483eWSP0L/a58fbdbbbca7273c97c3be7866fef414/LAL_5787.jpg',
    alt: 'A pink dachshund Top Dog award on an engraved wood base',
    ratio: 1.5,
  },
  freshlyBaked: {
    file: '6PUs1KHoP5nqTt2euAj2Xe/406b15a0c90b320a2a4ca60a1e55c5d9/LAL_5783.jpg',
    alt: 'A pink baby figure on a wood base engraved Freshly Baked, Rookie of the Year',
    ratio: 1.5,
  },
  beamie: {
    file: '73SQOxQdGcKLot3fFzSEUL/d343296391ef65a4e6faf8e977fa12cc/beamie_awards_2020_trophies.jpg',
    alt: 'A row of navy Beamie Awards 2020 trophies with pink logo tops',
    ratio: 1.5,
  },
  gcoty: {
    file: '2JKURJ4bMaldbxZ0C6253F/06d4be50735f80d6b95dc79bf9f38bf4/LAL_5087.jpg',
    alt: 'German Car of the Year 2020 award with layered lettering on a wood base',
    ratio: 1.43,
  },
  wanba: {
    file: '33hfyTe9iBSEOaYqMHGh2r/4fc77ecbbf6e52be0c426da8ab751a8b/LAL_6281.jpg',
    alt: 'Painted Wanba Warriors character trophies on black plinths',
    ratio: 1.5,
  },
  duck: {
    file: '481Bv2hknFxlBdNK8c2vyK/bdcdb110c4661e4ac0b18e4b850319c7/LAL_7404.jpg',
    alt: 'A black duck trophy perched on a grey display block for a hackathon',
    ratio: 1.5,
  },
  audible: {
    file: 'XXTpoLfzWtVAqNclzvSCH/6521ac7d1b710ceb290d61c38ea7ffbe/LAL_6101.jpg',
    alt: 'Orange and black painted cube awards for Audible',
    ratio: 1.5,
  },
  goldTowers: {
    file: '70PZRNWEfH94cm6ujgKF0F/1b266a24e16a3588d6057c7bc72aabca/LAL_6821.jpg',
    alt: 'Two tall gold-plated tower awards on round gold bases',
    ratio: 0.85,
  },
  mls: {
    file: '2B3cnOrGFrw6h0CoJfHq4W/6657f77fa2f0a45de114fba59c99b8fe/Custom_Awards_For_MLS.JPG',
    alt: 'Two presenters holding custom MLS awards on a stadium field',
    ratio: 1.5,
  },
  gold: {
    file: '2TEJynhwC56Gd9DQDzZrcU/31b3cab828bdba6957dee3d93e10877c/LAL_6816.jpg',
    alt: 'A pair of gold-plated soccer cleats',
    ratio: 1.5,
  },
  silver: {
    file: '3D2onW1AgQKeoXpGIYErQw/6601c64308f6cf484e03e4081e31cc6b/_DSC5698.jpg',
    alt: 'A silver clock held up by a slender figure',
    ratio: 0.69,
  },
  chrome: {
    file: '1zVMVg5lowRIaU9tefr4ek/0b6a45b8872e72c51f839bafc13e4736/LAL_4652.jpg',
    alt: 'Two twisted chrome cubes',
    ratio: 1.5,
  },
  bronze: {
    file: '5hKi0n2cf5vDuNSW9tVmUZ/b00767d4496950c7e713050efde7004d/_DSC3266.jpg',
    alt: 'A bronze plaque with a relief portrait and engraved text',
    ratio: 0.667,
  },
  painted: {
    file: '6DZolBxlZ6vjWHtP4XwwDF/73343f50aec84d069ccba2cfdb69020c/LAL_5156.jpg',
    alt: 'A yellow painted award spelling The Challenge',
    ratio: 1.5,
  },
  lightUp: {
    file: '4YHAyZ9NCYGE5SmCV3QIYn/22e177679e84d523aa53edd31d110b84/LAL_5142.jpg',
    alt: 'A blue and frosted innovation award that lights up',
    ratio: 0.667,
  },
}

// Hero mosaic: a 2x2 grid with a wider left column. Areas map to the CSS
// grid in custom-trophy.css; `focus` sets the crop point for cropped tiles.
const heroMosaic = [
  { photo: 'rcCatsSet', label: 'RC · Cat mascot awards', area: 'a' },
  {
    photo: 'formicArm',
    label: 'Formic · Robot arm',
    area: 'b',
    focus: '50% 56%',
    fill: true,
  },
  { photo: 'goGetter', label: 'Dunkin’ · Go Getter', area: 'c' },
  { photo: 'tribeGorillas', label: 'Tribe · Chrome gorillas', area: 'd' },
]

const work = [
  {
    photo: 'tribeGorillas',
    title: 'Tribe sales awards',
    caption: 'Top Closer and Top Setter, as chrome gorillas on black bases.',
  },
  {
    photo: 'rcCat',
    title: 'RC cat award',
    caption:
      'A gold cat in team colors and a headset, with flame wings on a twisted column.',
  },
  {
    photo: 'telly',
    title: 'Hat-tip characters',
    caption:
      'Two little characters tipping their hats, painted and mounted on black bases.',
  },
  {
    photo: 'topDog',
    title: 'Top Dog for 1000heads',
    caption:
      'A very long dog for the Head of the Year, on an engraved wood base.',
  },
  {
    photo: 'freshlyBaked',
    title: 'Freshly Baked',
    caption:
      'Rookie of the Year, so naturally it’s a baby. Painted resin on engraved wood.',
  },
  {
    photo: 'gcoty',
    title: 'German Car of the Year',
    caption: 'An annual award with raised lettering on a wood base.',
  },
  {
    photo: 'wanba',
    title: 'Wanba Warriors',
    caption:
      'Four characters, painted to match and paired up on black plinths.',
  },
  {
    photo: 'duck',
    title: 'Hackathon duck',
    caption:
      'A matte black duck for a hackathon. It gets its own display block.',
  },
  {
    photo: 'spark',
    title: 'Spark',
    caption:
      'Tall red lettering topped with stars, on black bases with each winner’s name.',
  },
]

// Formic case study. Facts come from the project email thread (Sept 21 to
// Oct 15, 2026); approved Sept 28, shipped Oct 15. Contacts, pricing, recipients and reorder plans stay private.
const formicCase = {
  photo: 'formicArm',
  eyebrow: 'Case study · Formic',
  title: 'A robot arm award for a company that installs robot arms.',
  body: [
    'PrintAWorld made 10 robot-arm awards for Formic using five fabrication processes, and shipped them 17 days after Formic approved the design.',
    'Formic puts industrial robots to work in factories. For its 2026 customer and partner awards, it wanted the trophy to be the thing it’s known for: a six-axis robot arm, in Formic’s own orange and black.',
    'It took five of our processes under one roof. We sent Formic a concept rendering the same day they reached out, then prepared the 3D file for printing and designed the mount that attaches the arm to its base. Each arm was printed in resin, painted to Formic’s RAL colors, and clear-coated, and the Formic graphics on it were UV printed onto the part. The base is 3D printed too, and weighted so the award feels solid in your hand. The Formic logo plate on the front was laser cut and UV printed, and each base carries a name plate for its winner.',
    'Because the bases are heavy, we shipped the arms off their bases so nothing could knock them around in transit, with the screws and an Allen key in the box.',
  ],
  specs: [
    ['Quantity', '10 awards'],
    ['Height', '8 in. (6 in. arm, 2 in. base)'],
    ['Colors', 'RAL 2009 orange, RAL 9005 black'],
    ['Approval to shipped', '17 days'],
  ],
  processes: [
    {
      name: '3D file prep',
      detail: 'The arm file made printable, plus a mount for the base',
      link: '/services/3d-modeling/',
    },
    {
      name: '3D printing',
      detail: 'Resin arm, plus a printed base weighted for a premium feel',
      link: '/services/3d-printing/',
    },
    {
      name: 'Laser cutting',
      detail: 'The Formic logo plate on the base',
      link: '/services/laser-cutting/',
    },
    {
      name: 'Painting and clear coat',
      detail: 'Matched to RAL 2009 and RAL 9005',
    },
    {
      name: 'UV printing',
      detail: 'Formic graphics on the arm and the logo plate',
      link: '/uv-printing-services/',
    },
  ],
}

// Request types drawn from the custom-trophy quote form (aggregate themes only;
// no client names or submissions are stored here).
const occasions = [
  {
    title: 'League and fantasy trophies',
    body: 'Fantasy football comes up a lot. So do hockey and office leagues. If the trophy gets handed down every year, tell us and we’ll leave room on the base for future winners.',
    link: [
      'Fantasy football trophies',
      '/services/custom-trophy/fantasy-football/',
    ],
  },
  {
    title: 'Sales and company awards',
    body: 'The company mascot or your product, made into the trophy itself. These work well for sales clubs and lifetime achievement awards.',
    link: ['Custom logo trophies', '/services/custom-trophy/logo-trophies/'],
  },
  {
    title: 'Tournaments',
    body: 'Golf, tennis, futsal, gaming. Sometimes it’s one championship trophy. Sometimes it’s a matching set for every division.',
  },
  {
    title: 'Events and fundraisers',
    body: 'Chili cook-offs, hackathons, conferences, charity drives. The kind of event where the trophy ends up in all the photos.',
  },
  {
    title: 'Copies and minis',
    body: 'A desk-sized copy of a trophy you already won, or of a landmark object. We can work from photos or scan the original.',
    link: ['About 3D scanning', '/services/3d-scanning/'],
  },
  {
    title: 'Plaques',
    body: 'Wall plaques with raised logos and lettering, painted or finished in metal.',
  },
]

const build = [
  {
    title: 'Sculpted forms',
    body: 'Anything with real depth, like a figure or a mascot, gets modeled in 3D and printed in resin. Then it’s sanded smooth so the paint or plating goes on clean.',
    link: ['How SLA resin printing works', '/services/sla-3d-printing/'],
  },
  {
    title: 'Flat and layered designs',
    body: 'Wordmarks and layered logos usually come out better cut from acrylic on the laser. It’s quicker and the edges are crisp. We’ll tell you which route makes sense for yours.',
    link: ['See laser cutting', '/services/laser-cutting/'],
  },
  {
    title: 'Bases and names',
    body: 'Most trophies sit on wood, acrylic, or a printed base. Each winner’s name goes on the front, engraved or printed.',
    link: ['See laser engraving', '/services/laser-engraving/'],
  },
]

const finishes = [
  {
    id: 'painted',
    name: 'Painted',
    photo: 'painted',
    body: 'Primed and painted in your colors, so it doesn’t look like plastic. If you need an exact brand color, tell us and we’ll check how close we can get.',
  },
  {
    id: 'gold',
    name: 'Gold',
    photo: 'gold',
    body: 'The one for first place.',
  },
  {
    id: 'silver',
    name: 'Silver',
    photo: 'silver',
    body: 'Softer than chrome. It suits slim figures and fine detail.',
  },
  {
    id: 'chrome',
    name: 'Chrome',
    photo: 'tribeGorillas',
    body: 'As shiny as it gets. These sales awards are chrome gorillas.',
  },
  {
    id: 'bronze',
    name: 'Bronze',
    photo: 'bronze',
    body: 'Warm and a little old-school. Good for plaques and portraits.',
  },
]

// Owner pricing from the custom-trophy pitch deck (2026-10-03). Per owner
// instruction, the deck's modeling-fee waiver for larger orders is not published.
// Tier photos follow the deck: painted resin cubes for the first range; the
// gold-plated pair is priced "+$1,000" on the site's own cost guide.
const pricing = {
  from: 250,
  // One-time 3D modeling fee per design: $250 for most projects (owner,
  // 2026-10-30); complex likenesses can run higher in the written quote.
  modelingFee: 250,
  tiers: [
    {
      photo: 'audible',
      name: 'Painted resin',
      price: '$250–$750',
      size: 'Standard size, 8–12 inches tall',
      body: 'Where most trophies land. Sculpted, printed in resin, sanded, and painted in your colors, like these cubes for Audible.',
    },
    {
      photo: 'goldTowers',
      name: 'Plated, gold, or large',
      price: '$750–$2,000+',
      size: '16 inches and taller start at $1,500',
      body: 'Metal plating, gold finishes, complex multi-color work, and big pieces. These gold-plated awards sit in this range.',
    },
  ],
  extras: [
    ['3D modeling and design', '$250 for most projects'],
    ['Concept mockup', 'Free'],
    ['Minimum order', 'None'],
  ],
}

const steps = [
  {
    title: 'Send your idea',
    body: 'A sketch or a photo is plenty. Tell us roughly how big, how many, the finish, what you’d like to spend per trophy, and when you need them.',
    approve: 'No 3D file needed',
  },
  {
    title: 'Get a free mockup',
    body: 'We send back a concept mockup of the trophy, free. Nothing is owed until you decide to go ahead.',
    approve: 'No commitment',
  },
  {
    title: 'We model and make it',
    body: 'Once you approve, we build the 3D model, then print it, sand it, paint or plate it, and add the names. If the job includes a sample, you see that first.',
    approve: 'You approve first',
  },
  {
    title: 'It ships',
    body: 'We pack it for the trip and send it anywhere in the U.S. Or pick it up at our New York studio by appointment.',
    approve: 'Shipped or picked up',
  },
]

const faqs = [
  {
    question: 'Do I need a 3D file to order a 3D printed trophy?',
    answer:
      'No. Most people send a sketch or a photo, and we build the 3D model from that. You’ll see renders before anything gets printed. If you do have a file, send it as an STL, OBJ, or STEP.',
  },
  {
    question: 'Is there a trophy builder or generator I can use?',
    answer:
      'You don’t need one. Describe what you want, or send a rough sketch, and we’ll design it with you. If you’ve already made something in a trophy generator or a CAD program, send the file and we’ll check whether it can be printed and finished as it is.',
  },
  {
    question: 'How much does a custom 3D printed trophy cost?',
    answer:
      'Trophies start at $250 each. Most are a standard 8 to 12 inches tall, painted resin, and land between $250 and $750. Metal plating, gold, and complex multi-color work run $750 to $2,000 or more, and anything 16 inches or taller starts at $1,500. There is also a one-time 3D modeling and design fee, $250 for most projects, and the concept mockup is free. Your written quote confirms the exact price before anything starts.',
  },
  {
    question: 'Can you make just one trophy?',
    answer:
      'Yes. There is no minimum order, so one trophy is fine. We get asked for single trophies all the time.',
  },
  {
    question: 'What are 3D printed trophies made of?',
    answer:
      'The sculpted parts are resin, printed in high detail and then sanded and painted or plated. Flat lettering and layered logos are usually laser-cut acrylic. Bases tend to be wood or acrylic.',
  },
  {
    question: 'Do 3D printed trophies look cheap?',
    answer:
      'A raw print can. That’s why everything we make gets sanded, primed, and painted or plated. If you want to see a finish up close before you decide, ask and we’ll send examples.',
  },
  {
    question: 'How far ahead should I order a custom trophy?',
    answer:
      'Standard turnaround is 4–6 weeks, so order as soon as you know the date. Rush orders in 1–2 weeks are possible; whether yours fits depends on how complex the design is, your budget and where it ships. Tell us your date when you ask for a quote.',
  },
  {
    question: 'Can you make a perpetual trophy with room for future winners?',
    answer:
      'Yes. Tell us at the start and we’ll design the base with room for name plates, so each year’s winner can be added.',
  },
  {
    question: 'Is a gold-plated trophy solid metal?',
    answer:
      'No. Plating puts a thin metal layer over the printed piece, so it looks like metal but isn’t solid metal underneath. Not every shape plates well, so we check each design before quoting it.',
  },
  {
    question: 'Do you sell stock or catalog trophies?',
    answer:
      'No. Everything we make is designed for one project. If you need a hundred identical medals for a few dollars each, a catalog trophy shop will serve you better.',
  },
  {
    question: 'Do you deliver?',
    answer:
      'Yes, to all 50 states. You can also pick up from our New York studio by appointment.',
  },
]

const resources = [
  [
    'How much does a custom trophy cost?',
    '/guides/how-much-does-a-custom-trophy-cost/',
  ],
  [
    'Crown Awards alternatives for a custom trophy',
    '/guides/crown-awards-alternatives/',
  ],
  [
    'Fantasy football punishments and last-place trophies',
    '/guides/fantasy-football-punishments/',
  ],
  [
    'Unique trophy and award ideas',
    '/blog/best-unique-custom-trophy-and-award-ideas/',
  ],
  ['Custom awards for brands', '/services/custom-awards/'],
  ['Metal plating', '/services/metal-plating/'],
  ['3D modeling', '/services/3d-modeling/'],
  ['Art fabrication', '/services/art-fabrication/'],
]

module.exports = {
  customTrophy,
  assetRoot,
  photoUrl,
  photos,
  heroMosaic,
  work,
  formicCase,
  occasions,
  build,
  finishes,
  pricing,
  steps,
  faqs,
  resources,
}
